import {Box, Heading, HStack, Link, VStack} from '@chakra-ui/react'
import {FaMapPin} from 'react-icons/fa'

import ContactCards from 'components/contact-cards'
import {NavSpacer} from 'components/nav'
import {grayRadialGradient, space} from 'config/theme'
import Layout from 'layouts/main'

export default function ContactPage() {
  return (
    <Layout title='Contact'>
      <Box background={grayRadialGradient}>
        <NavSpacer />
        <VStack p={space.lg} spacing={space.lg}>
          <VStack spacing={space.sm}>
            <Heading size='2xl' textAlign='center'>
              Our team is here to help
            </Heading>
            <Heading
              color='gray.600'
              fontWeight='normal'
              size='md'
              textAlign='center'
            >
              Get in touch and let us know what we can do for you.
            </Heading>
          </VStack>
          <ContactCards />
          <Heading
            color='gray.600'
            fontWeight='normal'
            size='md'
            textAlign='center'
          >
            You can also email us directly at{' '}
            <Link color='blue.600' href='mailto:support@conveyal.com'>
              support@conveyal.com
            </Link>
          </Heading>
          <HStack>
            <Box color='blue.500' fontSize='2xl'>
              <FaMapPin />
            </Box>
            <Heading
              as='address'
              color='gray.600'
              fontWeight='normal'
              size='md'
              textAlign='center'
              fontStyle='normal'
            >
              240 Elm Street, 2nd Floor, Somerville MA 02144
            </Heading>
          </HStack>
        </VStack>
      </Box>
    </Layout>
  )
}
